import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Col, Row, Button, Modal, Image, Table } from "react-bootstrap";


import Card from "../../../components/Card/Card";
// import { rutas } from "../../../routes_backend/routes";
import Loading from "../../../views/Loading";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import { get_Details } from "../../../components/utils/functions.js";
import _ from "lodash";
import check from "../../../assets/compras/check.png";
import "./styleModal.css";
import { dominio } from "../../../routes_backend/routes";


class Informe_de_estatus_de_autorizacion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      message: "",
      is_description: "1",
      options: [
        { id: "1", name: "VIBRO COMPACTADOS" },
        { id: "2", name: "AGREGADOS" },
        { id: "3", name: "LOGISTICA" },
      ],

      //JQXGRID
      columns: [
        {
          Header: "No. Preliminar",
          accessor: "DocEntry",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
        {
          Header: "Adjunto",
          accessor: "Adjunto",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
        {
          Header: "Documento",
          accessor: "Documento",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
        {
          Header: "Fecha Creacion",
          accessor: "FechaCreacion",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
        {
          Header: "Estado",
          accessor: "EstadoG",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
                background:
                  rowInfo && rowInfo.row.EstadoG === "Autorizado"
                    ? "#8CF349"
                    : rowInfo && rowInfo.row.EstadoG === "Creado"
                      ? "#47DBB7"
                      : rowInfo && rowInfo.row.EstadoG === "Pendiente"
                        ? "#EEF341"
                        : rowInfo && rowInfo.row.EstadoG === "No Aprobado"
                          ? "#F94E4E"
                          : null,
              },
            };
          },
        },
        {
          Header: "Comentario",
          accessor: "Remarks",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
        {
          Header: "test",
          accessor: "Comments",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
      ],

      subColumns: [
        {
          Header: "Autorizador",
          accessor: "Autorizador",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
        {
          Header: "Estado",
          accessor: "Estado",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
                background:
                  rowInfo && rowInfo.row.Estado === "Autorizado"
                    ? "#8CF349"
                    : rowInfo && rowInfo.row.Estado === "Creado"
                      ? "#47DBB7"
                      : rowInfo && rowInfo.row.Estado === "Pendiente"
                        ? "#EEF341"
                        : rowInfo && rowInfo.row.Estado === "No Aprobado"
                          ? "#F94E4E"
                          : null,
              },
            };
          },
        },
        {
          Header: "Fecha A.",
          accessor: "FechaA",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
        {
          Header: "Hora A.",
          accessor: "HoraA",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
        {
          Header: "Total Dias",
          accessor: "TotalDias",
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                fontSize: "12px",
              },
            };
          },
        },
      ],

      

      data: [],
      data_subColumns: [],
      data_fujo_compras: [],
      data_details: {},
      data_SKU: {},
      dias_totales: "",
      fecha_creacion: "",
      dias_autorizacion: "",
      DocEntry: "",
      Comments: "",
    };

  }
  clear = () => {
    this.setState({
      isLoading: false,
      message: "",
      is_description: "1",
      data: [],
    });
    this.abrirModalVistaPrevia = this.abrirModalVistaPrevia.bind(this);
    this.cerrarModalVistaPrevia = this.cerrarModalVistaPrevia.bind(this);

    this.abrirModalAdjuntos = this.abrirModalAdjuntos.bind(this);
    this.cerrarModalAdjuntos = this.cerrarModalAdjuntos.bind(this);
  };

  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };






   data_details = () => {

   this.setState({
      isLoading: true,
      message: "",
    });

    var userSign = ''
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);
    // console.log(token_Data);


    if (token_Data !== null) {
      token_Data.forEach((element) => {

        userSign = element.U_UserId;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }






    // Crea el objeto de datos para el POST
    const requestData = {
      userSign: userSign,  // Enviar el UserSign
    };


    // Establece la URL de la API
    let url_detail = `${dominio}/get_StatusAutorizacionDetalle`;
    let temp_array_details = []

    fetch(url_detail, {
      method: 'POST',  // Método POST
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),  // Envía el UserSign en el cuerpo
    
    })
   

      .then(async (res) => {
        let data = await res.json();

        

        // Maneja la respuesta
        let array = [];

          data.forEach((element) => {
          let obj = {
            Autorizador: element.Autorizador,
            Estado: element.EstadoD,
            FechaA: element.Fecha_Actualizacion,
            HoraA: element.Hora_Actualizacion,
            TotalDias: element.Dias_Para_Autorizacion,
            DocEntry: element.DocEntry,
            DraftEntry: element.DraftEntry,
          };
          array.push(obj);
          temp_array_details.push(obj);
          console.log(temp_array_details);
        });

        this.data(temp_array_details);
        this.setState({
          isLoading: false,
          message: "",
          data_subColumns: array,
        });
      })
      .catch((error) => {
        this.data(temp_array_details);
        this.setState({
          isLoading: false,
          message: "error in the server",
        });
      });
  };



      data = (details) => {


    var userSign = ''
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);
    // console.log(token_Data);


    if (token_Data !== null) {
      token_Data.forEach((element) => {

        userSign = element.U_UserId;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }


    this.setState({
      isLoading: true,
      message: "",
      data: [],
    });




    // Crea el objeto de datos para el POST
    const requestData = {
      userSign: userSign,  // Enviar el UserSign
    };


    // Establece la URL de la API
    let url = `${dominio}/get_StatusAutorizacion`;


    fetch(url, {
      method: 'POST',  // Método POST
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),  // Envía el UserSign en el cuerpo
    })
      .then(async (res) => {
        let data = await res.json();

        // console.log(data);

        // Maneja la respuesta
        let array = [];

        data.forEach((element) => {
          var year = element.FechaCreacion.slice(6, 10);
          var month = element.FechaCreacion.slice(3, 5);
          var day = element.FechaCreacion.slice(0, 2);
          let date = year + "-" + month + "-" + day;
          let obj = {
            is_description: this.state.is_description,
            DocType: element.DocType,
            DocNum: element.DocNum,
            DocEntry: element.DocEntry,
            Adjunto: element.Adjunto,
            Documento: element.Documento,
            FechaCreacion: date,
            EstadoG: element.EstadoG,
            Remarks: element.Remarks,
            Comments: element.Comments,
            Name: element.Name,
            IsDraft: element.IsDraft,
            draftKey: element.draftKey,
            types:
              parseInt(this.state.is_description) === 3
                ? get_Details(details, parseInt(element.DraftEntry))
                : get_Details(details, parseInt(element.DraftEntry)),
          };

          array.push(obj);
        });

        this.setState({
          isLoading: false,
          message: "",
          data: array,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          isLoading: false,
          message: "error in the server",
        });
      });
  };





  search_adjunto = async (DocEntry, Adjunto) => {
     const { is_sociedad } = this.state;
      console.log(DocEntry);
      
    
      var username = '';
      var password = '';
      var codigoUser = '';
      let token = localStorage.getItem('token');
      let token_Data = JSON.parse(token);
    
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
          codigoUser = element.U_UserId;
        });
      }
    
      if (token_Data === null) {
        this.props.history.push('');
      }
    
      this.setState({
        message: "",
        isLoading: true,
      });
    
      const response = fetch(`${dominio}/get_ListRequisicionesAdjuntos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          username,
          password,
          codigoUser,
          is_sociedad,
          DocEntry
        }),
      });
    
      response
        .then(async (res) => {
          let data = await res.json();
          const adjuntoBase64 = data.length > 0 ? data[0].doc : null;
    
          this.setState({
            isLoading: false,
            isModalOpenAdjuntos: true,
            adjuntoBase64, // Guardamos el adjunto en base64
          });
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
          });
        });
  };
  


  
  
  cerrarModalAdjuntos() {
    this.setState({ isModalOpenAdjuntos: false });
  }


//   abrirModalVistaPrevia = (code, type, is_description) => {

// console.log(is_description);
// console.log(type);



//     // console.log(code, type, is_description, "----");
//     // console.log(code, type);
//     if (is_description === "1") {
 
//         // window.open("http://190.56.9.222/Draft/vistaPrevia/" + code);

//         let solicitud = code;
//         let codigoUser = '';

//         var username = '';
//         var password = '';
//         // var codigoUser = '';
//         let token = localStorage.getItem('token');
//         let token_Data = JSON.parse(token);

//         if (token_Data !== null) {
//           token_Data.forEach((element) => {
//             username = 'manager';
//             password = '1234';
//             codigoUser = element.U_UserId;
//           });
//         }
//         console.log(codigoUser);
        
//         if (token_Data === null) {
//           this.props.history.push('');
//         }
//         console.log(token_Data);



//         this.setState({
//           message: "",
//           isLoading: true,

//         });

//         const response = fetch(`dominio/get_ListRequisicionesVistaPrevia`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             username,
//             password,
//             solicitud,
//           }),
//         });


//         // let url = `${rutas.get_list_autorizaciones}/?user=${user}&sociedad=${is_sociedad} `;
//         // console.log(url);

//         response
//           .then(async (res) => {
//             let data = await res.json();

//             console.log(data);


//             this.setState({
//               listAutorizacionesVistaPrevia: data,
//               isLoading: false,
//               isModalOpenVistaPrevia: true,

//             });


//           })
//           .catch((error) => {
//             console.log(error);
//             this.setState({
//               isLoading: false,
//               message: 'No hay autorizaciones pendientes con este usuario'
//             });
//           });





  
//     }
//     if (is_description === "2") {


//         // window.open("http://190.56.9.222:8007/DraftSI/vistaPrevia/" + code);

//         let solicitud = code;
//         let codigoUser = '';

//         // var username = '';
//         // var password = '';
//         // var codigoUser = '';
//         let token = localStorage.getItem('token');
//         let token_Data = JSON.parse(token);

//         if (token_Data !== null) {
//           token_Data.forEach((element) => {
//             username = 'manager';
//             password = '1234';
//             codigoUser = element.U_UserId;
//           });
//         }
// console.log(codigoUser);

//         if (token_Data === null) {
//           this.props.history.push('');
//         }
//         console.log(token_Data);



//         this.setState({
//           message: "",
//           isLoading: true,

//         });

//         const response = fetch(`http://190.56.9.222:4000/get_ListRequisicionesVistaPrevia`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             username,
//             password,
//             solicitud,
//           }),
//         });


//         // let url = `${rutas.get_list_autorizaciones}/?user=${user}&sociedad=${is_sociedad} `;
//         // console.log(url);

//         response
//           .then(async (res) => {
//             let data = await res.json();

//             console.log(data);


//             this.setState({
//               listAutorizacionesVistaPrevia: data,
//               isLoading: false,
//               isModalOpenVistaPrevia: true,

//             });


//           })
//           .catch((error) => {
//             console.log(error);
//             this.setState({
//               isLoading: false,
//               message: 'No hay autorizaciones pendientes con este usuario'
//             });
//           });






   
//     }
//     if (is_description === "3") {

//         // window.open("http://190.56.9.222/DraftTra/vistaPrevia/" + code);


        
//         let solicitud = code;
//         let codigoUser = '';

//         // var username = '';
//         // var password = '';
//         // var codigoUser = '';
//         let token = localStorage.getItem('token');
//         let token_Data = JSON.parse(token);

//         if (token_Data !== null) {
//           token_Data.forEach((element) => {
//             username = 'manager';
//             password = '1234';
//             codigoUser = element.U_UserId;
//           });
//         }
// console.log(codigoUser);

//         if (token_Data === null) {
//           this.props.history.push('');
//         }
//         console.log(token_Data);



//         this.setState({
//           message: "",
//           isLoading: true,

//         });

//         const response = fetch(`http://190.56.9.222:7000/get_ListRequisicionesVistaPrevia`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             username,
//             password,
//             solicitud,
//           }),
//         });


//         // let url = `${rutas.get_list_autorizaciones}/?user=${user}&sociedad=${is_sociedad} `;
//         // console.log(url);

//         response
//           .then(async (res) => {
//             let data = await res.json();

//             console.log(data);


//             this.setState({
//               listAutorizacionesVistaPrevia: data,
//               isLoading: false,
//               isModalOpenVistaPrevia: true,

//             });


//           })
//           .catch((error) => {
//             console.log(error);
//             this.setState({
//               isLoading: false,
//               message: 'No hay autorizaciones pendientes con este usuario'
//             });
//           });



    
//     }
//   };



    abrirModalVistaPrevia(code, type, codigoUser) {
      
  
      
  
      // if (is_sociedad === 'SBO_MOSA') {
  
  
        var username = '';
        var password = '';
        // var codigoUser = '';
        let token = localStorage.getItem('token');
        let token_Data = JSON.parse(token);
    
        if (token_Data !== null) {
          token_Data.forEach((element) => {
            username = element.usuarioSAP;
            password = element.contraseñaSAP;
            codigoUser = element.U_UserId;
          });
        }
    
        if (token_Data === null) {
          this.props.history.push('');
        }
        console.log(token_Data);
        
    
    
        this.setState({
          message: "",
          isLoading: true,
         
        });

        let solicitud = code
  
        console.log(code);
        
    
        const response = fetch(`${dominio}/get_ListRequisicionesVistaPrevia`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            username,
            password,
            solicitud,
          }),
          });
    
    
        // let url = `${rutas.get_list_autorizaciones}/?user=${user}&sociedad=${is_sociedad} `;
        // console.log(url);
    
        response
        .then(async (res) => {
          let data = await res.json();
    
          console.log(data);
          
    
          this.setState({
            listAutorizacionesVistaPrevia: data,
            isLoading: false,
            isModalOpenVistaPrevia: true,
  
          });
        
      
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
            message: 'No hay autorizaciones pendientes con este usuario'
          });
        });
      // }
      // if (this.state.id_sociedad === 2) {
      //   if (type === "I") {
      //     window.open(
      //       "http://190.56.9.222:8012/DraftSI/vistaPrevia/" + solicitud
      //     );
      //   }
      //   if (type !== "I") {
      //     window.open(
      //       "http://190.56.9.222:8012/DraftSI/vistaPreviaS/" + solicitud
      //     );
      //   }
      // }
      // if (this.state.id_sociedad === 3) {
      //   window.open("http://190.56.9.222/DraftTra/vistaPrevia/" + solicitud);
      // }
  
  
    }

  cerrarModalVistaPrevia = () => {
    this.setState({ isModalOpenVistaPrevia: false });
  }
  cerrarModalAdjuntos= () => {
    this.setState({ isModalOpenAdjuntos: false });
  }


  componentDidMount() {
    //  this.data();
     this.data_details();
  }
  handleClose = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { is_description, isModalOpenVistaPrevia, listAutorizacionesVistaPrevia, isModalOpenAdjuntos } = this.state;


    const total = Array.isArray(listAutorizacionesVistaPrevia)
      ? listAutorizacionesVistaPrevia.reduce((acc, item) => acc + parseFloat(item.LineTotal), 0).toFixed(2)
      : '0.00';

    // const formatDate = (dateString) => {
    //   const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    //   const date = new Date(dateString);
    //   return new Intl.DateTimeFormat('es-ES', options).format(date);
    // };

    const columnas = [
      {
        Header: "Autorizacion",
        accessor: "draftKey",
        //width: 85,
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
      {
        Header: "No. Preliminar",
        accessor: is_description ? "DocNum" : "DocEntry",
        //width: 100,
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
            onClick: (e) => {
              // console.log(rowInfo);
            },
          };
        },
        Cell: (props) => (
          <Button
            bsStyle={props.original.DocType === "I" ? "primary" : "info"}
            bsSize="small"
            /*  disabled={
              props.original.IsDraft === "N"
                ? true
                : props.original.IsDraft === undefined
                ? false
                : false
            } */
            active
            onClick={() =>
              this.abrirModalVistaPrevia(
                //props.original.DocEntry,
                is_description === "1"
                  ? props.original.draftKey
                  : is_description === "2"
                    ? props.original.draftKey
                    : props.original.draftKey,
                props.original.DocType,
                props.original.is_description
              )
            }
          >
            {props.row.DocNum !== undefined
              ? props.row.DocNum
              : props.original.DocEntry}
          </Button>
        ),
      },

      {
        Header: "Descripcion",
        accessor: "Remarks",
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
      {
        Header: "Adjunto",
        accessor: "Adjunto",
        //width: 85,
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
        Cell: (props) => (
          <Button
            bsStyle="primary"
            bsSize="small"
            active
            disabled={
              parseInt(props.row.Adjunto) === null
                ? true
                : props.row.Adjunto === null
                  ? true
                  : false
            }
            onClick={() =>
              this.search_adjunto(
                props.original.Adjunto,
                props.original.DocType,
                props.original.is_description
              )
            }
          >
            {"Ver"}
          </Button>
        ),
      },
      // {
      //   Header: "Flujo Compra",
      //   accessor: "flujo",
      //   //width: 100,
      //   getProps: (state, rowInfo, column) => {
      //     return {
      //       style: {
      //         fontSize: "12px",
      //       },
      //     };
      //   },
      //   Cell: (props) => (
      //     <Button
      //       bsStyle="primary"
      //       bsSize="small"
      //       active
      //       disabled={
      //         this.state.data_fujo_compras.find(
      //           (element) => element.Requisicion === props.original.DocEntry
      //         ) !== undefined
      //           ? false
      //           : true
      //       }
      //       onClick={() =>
      //         this.flujoCompra(
      //           props.original.DocEntry,
      //           props.original.FechaCreacion,
      //           props.original.types,
      //           props.original.Comments
      //         )
      //       }
      //     >
      //       {"Flujo Compra"}
      //     </Button>
      //   ),
      // },

      {
        Header: "Departamento",
        accessor: "Name",
        //width: 120,
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
      {
        Header: "Fecha Creacion",
        accessor: "FechaCreacion",
        //width: 95,
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
      {
        Header: "Estado",
        accessor: "EstadoG",
        //width: 85,
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
              background:
                rowInfo && rowInfo.row.EstadoG === "Autorizado"
                  ? "#8CF349"
                  : rowInfo && rowInfo.row.EstadoG === "Creado"
                    ? "#47DBB7"
                    : rowInfo && rowInfo.row.EstadoG === "Pendiente"
                      ? "#EEF341"
                      : rowInfo && rowInfo.row.EstadoG === "No Aprobado"
                        ? "#F94E4E"
                        : null,
            },
          };
        },
      },

      {
        Header: "Comentario",
        accessor: "Comments",
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
    ];

    return (
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >
        <Grid fluid>
          <Row>
            <Col md={12}>

            <div className="modal" tabIndex="-1" role="dialog" style={{ display: isModalOpenAdjuntos ? 'block' : 'none' }}>
  <div className="modal-dialog-custom-width" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Vista Previa</h5>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.cerrarModalAdjuntos}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body" style={{ height: '700px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        {this.state.adjuntoBase64 ? (
          this.state.adjuntoBase64.length > 300 * 1024 ? ( // 300 KB en bytes
            <>
              <p>El archivo es muy grande para renderizar. Descárguelo para verlo.</p>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = `data:application/pdf;base64,${this.state.adjuntoBase64}`;
                  link.download = 'adjunto.pdf'; // Nombre del archivo descargado
                  link.click();
                }}
              >
                Descargar
              </button>
            </>
          ) : (
            <iframe
              src={`data:application/pdf;base64,${this.state.adjuntoBase64}`}
              style={{ width: '100%', height: '100%' }}
              frameBorder="0"
            ></iframe>
          )
        ) : (
          <p>No hay adjunto para mostrar</p>
        )}
      </div>
      <div className="modal-footer">
        {this.state.adjuntoBase64 && this.state.adjuntoBase64.length > 300 * 1024 && (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              const link = document.createElement('a');
              link.href = `data:application/pdf;base64,${this.state.adjuntoBase64}`;
              link.download = 'adjunto.pdf'; // Nombre del archivo descargado
              link.click();
            }}
          >
            Descargar
          </button>
        )}
        <button type="button" className="btn btn-secondary" onClick={this.cerrarModalAdjuntos}>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>



              <div className="modal" tabIndex="-1" role="dialog" style={{ display: isModalOpenVistaPrevia ? 'block' : 'none' }}>
                <div className="modal-dialog-custom-width" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Vista Previa</h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={this.cerrarModalVistaPrevia}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      {Array.isArray(listAutorizacionesVistaPrevia) && listAutorizacionesVistaPrevia.length > 0 && (
                        <>
                          <div>
                            <strong>Solicitante:</strong> {listAutorizacionesVistaPrevia[0].U_NAME} &nbsp;&nbsp;&nbsp;
                            <strong># Documento:</strong> {listAutorizacionesVistaPrevia[0].DraftEntry}
                          </div>
                          <table>
                            <thead>
                              <tr>
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                {/* <th>Precio con IVA</th> */}
                                <th>Almacen</th>
                                <th>Cantidad</th>
                                <th>Stock</th>
                                <th>Comprometido</th>
                                <th>Precio</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {listAutorizacionesVistaPrevia.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.ItemCode}</td>
                                  <td>{item.Dscription}</td>
                                  {/* <td>{parseFloat(item.PriceAfVAT).toFixed(2)}</td> */}
                                  <td>{item.WhsCode}</td>
                                  <td>{item.Quantity}</td>
                                  <td>{item.IsCommited}</td>
                                  <td>{item.OnHand}</td>
                                  <td>{parseFloat(item.Price).toFixed(2)}</td>
                                  <td>{parseFloat(item.LineTotal).toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="info-section">
                            <div className="comments">
                              <strong>Comentario:</strong>
                              &nbsp;
                              {listAutorizacionesVistaPrevia[0].Comments}
                            </div>
                            <div className="total">
                              <strong>Total:</strong> {total}
                              <br />
                              <strong>Total/IVA:</strong> {parseFloat(listAutorizacionesVistaPrevia[0].DocTotal).toFixed(2)}
                            </div>
                          </div>
                          <div className="create-date">
                            {/* <strong>Fecha Creacion:</strong> {formatDate(listAutorizacionesVistaPrevia[0].CreateDate)} */}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={this.cerrarModalVistaPrevia}>
                        Cerrar
                      </button>
                    </div>
                  </div>
                </div>
              </div>



              <Card
                title="INFORME DE ESTATUS DE AUTORIZACION"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="contet">
                    <div className="row">
              
                     
                    </div>

                    {!_.isEmpty(this.state.data) ? (
                      <div className="row">
                        <div className="col-sm-12">
                          <br /> <br />
                          <ReactTable
                            data={this.state.data}
                            columns={columnas}
                            filterable={true}
                            // defaultPageSize={this.state.data.length}
                            freezWhenExpanded={true}
                            defaultFilterMethod={(filter, row, column) => {
                              const id = filter.pivotId || filter.id;
                              if (typeof filter.value === "object") {
                                return row[id] !== undefined
                                  ? filter.value.indexOf(row[id]) > -1
                                  : true;
                              } else {
                                return row[id] !== undefined
                                  ? String(row[id]).indexOf(filter.value) > -1
                                  : true;
                              }
                            }}
                            SubComponent={(row) => {
                              return (
                                <ReactTable
                                  data={row.original.types}
                                  columns={this.state.subColumns}
                                  defaultPageSize={5}
                                  showPagination={false}
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.isLoading === false
                      ? this.state.show && (
                        <Modal
                          show={this.state.showModal}
                          onHide={this.handleClose}
                          bsSize="large"
                        >
                          <Modal.Header closeButton />
                          <Modal.Body>
                            <div className="row">
                              <div className="col-sm-12">
                                <center>
                                  <p>
                                    <strong>
                                      PROCESO DE FLUJO DE COMPRA
                                    </strong>
                                  </p>
                                  <br />
                                  <br />
                                </center>
                              </div>
                              <br />
                            </div>
                            <div className="row">
                              <div
                                className="col-sm-12"
                                style={{ textAlign: "end", marginTop: "-5%" }}
                              >
                                <label htmlFor="">Grupo : </label>
                                <p>
                                  {this.state.data_details &&
                                    this.state.data_details.Grupo !== undefined
                                    ? this.state.data_details.Grupo
                                    : ""}
                                </p>
                              </div>
                            </div>
                            <br />
                            <div className="row">
                              <div className="col-sm-12">
                                <p>
                                  <strong> Departamento : </strong>
                                  {this.state.data_details &&
                                    this.state.data_details.Departamento !==
                                    undefined
                                    ? this.state.data_details.Departamento
                                    : ""}
                                </p>
                              </div>
                            </div>
                            <br />
                            <div className="row">
                              <div className="col-sm-12">
                                <p>
                                  <strong> Usuario que Solicita : </strong>
                                  {this.state.data_details &&
                                    this.state.data_details.Usuario !==
                                    undefined
                                    ? this.state.data_details.Usuario
                                    : ""}
                                </p>
                              </div>
                            </div>
                            <br />
                            <div className="row">
                              <div className="col-sm-12">
                                <p>
                                  <strong> Proyecto : </strong>
                                  {this.state.data_details &&
                                    this.state.data.DocEntry !== undefined
                                    ? this.state.data_details.Proyecto
                                    : ""}
                                </p>
                              </div>
                            </div>
                            <br />
                            <div className="row">
                              <div className="col-sm-12">
                                <p>
                                  <strong> DocEntry : </strong>
                                  {this.state.DocEntry &&
                                    this.state.DocEntry !== undefined
                                    ? this.state.DocEntry
                                    : ""}
                                </p>
                              </div>
                            </div>
                            <br />

                            <div className="row">
                              <div className="col-sm-12">
                                <p>
                                  <strong> Comentario : </strong>
                                  {this.state.Comments}
                                </p>
                              </div>
                            </div>
                            <br />
                            <div
                              className="row"
                              style={{
                                textAlign: "center",
                                alignItems: "center",
                              }}
                            >
                              <div className="col-sm-12">
                                <Table striped hover responsive bordered>
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        SKU
                                      </th>

                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Almacen
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Descripcion
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Cantidad
                                      </th>
                                    </tr>
                                  </thead>
                                  {this.state.data_SKU !== undefined
                                    ? this.state.data_SKU.map((res, idx) => (
                                      <tbody key={idx}>
                                        <tr>
                                          <td>
                                            {res.SKU !== undefined
                                              ? res.SKU
                                              : ""}
                                          </td>

                                          <td>
                                            {res.Almacen !== undefined
                                              ? res.Almacen
                                              : ""}
                                          </td>
                                          <td>
                                            {res.Descripcion !== undefined
                                              ? res.Descripcion
                                              : ""}
                                          </td>
                                          <td>
                                            {res.cantidad !== undefined
                                              ? res.cantidad
                                              : ""}
                                          </td>
                                        </tr>
                                      </tbody>
                                    ))
                                    : ""}
                                </Table>
                              </div>
                              <div className="col-sm-12">
                                <Table striped hover responsive bordered>
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {""}
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Numero de Requisicion
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Numero de Orden
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Numero de Ingreso
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{""}</td>
                                      <td>
                                        {this.state.data_details.Requisicion}
                                      </td>
                                      <td>{this.state.data_details.Orden}</td>
                                      <td>
                                        {this.state.data_details.Ingreso !== 0
                                          ? this.state.data_details.Ingreso
                                          : "PENDIENTE"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                              <div className="col-sm-12">
                                <Table striped hover responsive bordered>
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Fecha Creacion de Solicitud
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Fecha Solicitud de Compra
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Fecha Orden de Compra
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Fecha Ingreso Bodega
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{this.state.fecha_creacion}</td>
                                      <td>
                                        {this.state.data_details &&
                                          this.state.data_details
                                            .FechaRequisicion !== undefined
                                          ? this.state.data_details.FechaRequisicion.slice(
                                            0,
                                            -9
                                          )
                                          : "PENDIENTE"}
                                      </td>
                                      <td>
                                        {this.state.data_details
                                          .FechaOrden !== ""
                                          ? this.state.data_details.FechaOrden.slice(
                                            0,
                                            -9
                                          )
                                          : "PENDIENTE"}
                                      </td>
                                      <td>
                                        {this.state.data_details
                                          .FechaIngreso !== ""
                                          ? this.state.data_details.FechaIngreso.slice(
                                            0,
                                            -9
                                          )
                                          : "PENDIENTE"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                              <div className="col-sm-12">
                                <Table striped hover responsive bordered>
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Dias de Autorizacion
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Dias de Solicitud
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Dias de Ingreso
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Dias Total
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{this.state.dias_autorizacion}</td>
                                      <td>
                                        {this.state.data_details &&
                                          this.state.data_details
                                            .DiasParaOrdene !== undefined
                                          ? this.state.data_details
                                            .DiasParaOrdene
                                          : ""}
                                      </td>
                                      <td>
                                        {this.state.data_details &&
                                          this.state.data_details
                                            .DiasParaIngreso !== undefined
                                          ? this.state.data_details
                                            .DiasParaIngreso
                                          : ""}
                                      </td>
                                      {/* 	<td>
																				{this.state.data_details &&
																				this.state.data_details.DiasTotal !==
																					undefined ? (
																					this.state.data_details.DiasTotal
																				) : (
																					''
																				)}
																			</td> */}
                                      <td>{this.state.dias_totales}</td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                              <div className="col-sm-12">
                                <Table striped hover responsive bordered>
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        SOLICITUD
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        ORDEN
                                      </th>
                                      <th
                                        style={{
                                          textAlign: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        BODEGA
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>
                                        {this.state.data_details &&
                                          this.state.data_details
                                            .FechaRequisicion !== undefined ? (
                                          <Image
                                            src={check}
                                            style={{
                                              width: "70px",
                                              height: "auto",
                                            }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td>
                                        {this.state.data_details
                                          .FechaOrden !== "" ? (
                                          <Image
                                            src={check}
                                            style={{
                                              width: "70px",
                                              height: "auto",
                                            }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td>
                                        {this.state.data_details
                                          .FechaIngreso !== "" ? (
                                          <Image
                                            src={check}
                                            style={{
                                              width: "70px",
                                              height: "auto",
                                            }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </Modal.Body>
                        </Modal>
                      )
                      : null}
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.isLoading && <Loading />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Informe_de_estatus_de_autorizacion);
const style = {
  text: {
    textAlign: "center",
  },
  ColorCell: {
    textAlign: "center",
    backgroundColor: "#dddddd",
    border: "0px solid",
    color: "#000",
  },
  errorMessage: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
};
